import { Component, OnInit } from '@angular/core';
import { BaseWithBundleComponent } from '../base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent extends BaseWithBundleComponent implements OnInit {

  constructor(bundle: ComponentServiceBundle) {
    super(bundle);
    this._idPrefix = 'breadcrumb.';
  }

  get breadcrumbs() {
    return this.breadcrumbsService.breadcrumbs;
  }

  ngOnInit() {
  }

}
